/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './provided-item.reducer';

export const ProvidedItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const providedItemEntity = useAppSelector(state => state.providedItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="providedItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.providedItem.detail.title">ProvidedItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.providedItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{providedItemEntity.id}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.providedItem.price">Price</Translate>
            </span>
          </dt>
          <dd>{providedItemEntity.price}</dd>
          <dt>
            <span id="dateOfServed">
              <Translate contentKey="tinyMedicRestApp.providedItem.dateOfServed">Date Of Served</Translate>
            </span>
          </dt>
          <dd>{providedItemEntity.dateOfServed}</dd>
          <dt>
            <span id="numberOfConsumptions">
              <Translate contentKey="tinyMedicRestApp.providedItem.numberOfConsumptions">Number Of Consumptions</Translate>
            </span>
          </dt>
          <dd>{providedItemEntity.numberOfConsumptions}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.providedItem.status">Status</Translate>
            </span>
          </dt>
          <dd>{providedItemEntity.status}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.providedItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{providedItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.providedItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>
            {providedItemEntity.microSec ? <TextFormat value={providedItemEntity.microSec} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.providedItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>
            {providedItemEntity.timestampEntry ? (
              <TextFormat value={providedItemEntity.timestampEntry} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.providedItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>
            {providedItemEntity.lastUpdated ? (
              <TextFormat value={providedItemEntity.lastUpdated} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.providedItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{providedItemEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.providedItem.claimItem">Claim Item</Translate>
          </dt>
          <dd>{providedItemEntity.claimItem ? providedItemEntity.claimItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.providedItem.patient">Patient</Translate>
          </dt>
          <dd>{providedItemEntity.patient ? providedItemEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.providedItem.bill">Bill</Translate>
          </dt>
          <dd>{providedItemEntity.bill ? providedItemEntity.bill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/provided-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/provided-item/${providedItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProvidedItemDetail;
